import { type ContractDataType } from '@/common/types/contract';

const checkExpiredStatus = (
  contract: ContractDataType | undefined,
): boolean => {
  const isAllFieldsExist =
    !!contract?.contractTimerExtensionCost &&
    !!contract.contractTimerExtensionDuration &&
    !!contract.contractTimerExtensionLimitTimeSinceOpened;

  if (!isAllFieldsExist || !contract.timeLeft) return false;

  const restTime =
    (contract.contractTimerExtensionDuration || 0) +
    Math.floor(contract.timeLeft / 1000);

  return restTime > 0;
};

export { checkExpiredStatus };
